// eslint-disable-next-line import/prefer-default-export
export enum CredentialStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  INVALID = 'invalid',
  INSUFFICIENT_PERMISSIONS = 'insufficient-permissions',
  WARNING = 'warning',
  ERROR = 'error',
}
